var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
export var createMuiTableOverrides = function (_a) {
    var typography = _a.typography;
    return {
        styleOverrides: {
            root: {
                // this allows the table to scroll horizontally on smaller screens
                minWidth: 400,
                '& caption': __assign({}, typography.caption),
            },
        },
    };
};
